import { render, staticRenderFns } from "./SubordinatesList.vue?vue&type=template&id=1160ea19"
import script from "./SubordinatesList.vue?vue&type=script&lang=js"
export * from "./SubordinatesList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports